import Content from './Article/Content/Content';
import RelatedArticles from './Article/RelatedArticles/RelatedArticles';

export default function Article({ fields }) {
  return (
    <div className="container">
      <Content fields={fields} />
      <RelatedArticles fields={fields} />
    </div>
  );
}
